import collectionCategories from '../data/collection-categories'

export default function useCollectionCategories() {
    return {
        collectionCategories,
        loading: false,
        error: null
    }
}
